import { render, staticRenderFns } from "./SummaryPanel.vue?vue&type=template&id=564e8ed0"
import script from "./SummaryPanel.vue?vue&type=script&lang=js"
export * from "./SummaryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports